 (function () {
  function initCarousel(container) {
    if (!container || container.dataset.carouselInit === 'true') return;
    container.dataset.carouselInit = 'true';

    const slides = Array.from(container.querySelectorAll('.image-with-text-media__slide'));
    if (slides.length === 0) return;

    const autoplay = container.dataset.autoplay === 'true';
    const interval = parseInt(container.dataset.interval, 10) || 4000;

    let index = 0;
    slides.forEach((slide, i) => {
      if (i === 0) {
        slide.classList.add('is-active');
      } else {
        slide.classList.remove('is-active');
      }
    });

    if (!autoplay || slides.length === 1) return;

    // Store interval ID for cleanup
    const intervalId = setInterval(() => {
      // Stop if container is removed from DOM
      if (!document.body.contains(container)) {
        clearInterval(intervalId);
        return;
      }
      
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, interval);
    
    // Store for potential cleanup
    container._carouselInterval = intervalId;
  }

  function initAll(root) {
    const scope = root || document;
    scope
      .querySelectorAll('[data-image-with-text-media-carousel]')
      .forEach((container) => initCarousel(container));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
